
<template>
  <v-layout class="activity-summary-list-item">
    <!-- mobile layout -->
    <v-flex xs12 class="ma-0 pa-0" hidden-sm-and-up>
      <v-btn
        class="text-none fill-width"
        large
        depressed
        :to="{ name: activityRouteName, params: { id:item.id} }"
      >
        <div class="outer-container">
          <img
            :src="$ic.getImageUrl('activity', item.type)"
            class="medium-thumbnail image-accent-dark"
          >
          <div class="vertical-container">
            <h3 class="primary--text font-weight-light text-truncate" style="max-width: 200px">{{ item.name }}</h3>
            <div class="d-flex" >
               <h5 class="data-cell" v-html="$bc.distanceFormat(item.distance,'major')"/>
               <h5 class="data-cell" v-html="$bc.elevationFormat(item.total_elevation_gain)"/>
               <h5 class="data-cell" v-html="$bc.timeFormat(item.elapsed_time)"/>
            </div>
            <!-- <small v-html="$bc.elevationFormat(item.total_elevation_gain)"/> -->
          </div>
          <div class="ml-auto vertical-container">
            <small class="ml-auto primary--text">{{ $bc.fromNow(item.start_date) }}</small>
            <small class="text-muted">{{ $bc.dateFormat(item.start_date, 'ddd DD/MMM/YYYY') }}</small> 
          </div>
        </div>
      </v-btn>
    </v-flex>
    <!-- standard layout -->
    <v-flex xs12 class="ma-0 pa-0" hidden-xs-only>
      <v-btn
        class="text-none fill-width"
        large
        depressed
        :to="{ name: activityRouteName, params: { id:item.id} }"
      >
        <div class="outer-container">
          <img
            :src="$ic.getImageUrl('activity', item.type)"
            class="medium-thumbnail image-accent-dark"
          >
          <div class="vertical-container">
            <h3 class="primary--text font-weight-light text-truncate" style="max-width: 200px">{{ item.name }}</h3>
            <div class="d-flex" >
               <h5 class="data-cell" v-html="$bc.distanceFormat(item.distance,'major')"/>
               <h5 class="data-cell" v-html="$bc.elevationFormat(item.total_elevation_gain)"/>
               <h5 class="data-cell" v-html="$bc.timeFormat(item.elapsed_time)"/>
            </div>
            <!-- <small v-html="$bc.elevationFormat(item.total_elevation_gain)"/> -->
          </div>
          <div class="ml-auto vertical-container">
            <small class="ml-auto primary--text">{{ $bc.fromNow(item.start_date) }}</small>
            <small class="text-muted">{{ $bc.dateFormat(item.start_date, 'ddd DD/MMM/YYYY') }}</small> 
          </div>
        </div>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'activity-summary-list-item',
  props: {
    item: {
      type: Object,
      default: null,
    },
    activityRouteName: {
      type: String,
      default: 'activityBottomNav',
    },
  },
  data: () => ({
  }),
  methods: {
  },
};
</script>

<style lang="scss">
.activity-summary-list-item {
  .outer-container {
    display: flex;
    flex-grow: 1;
    width: 100%;
  }
  .vertical-container {
    display: flex;
    flex-direction: column;
  }
  button {
    margin: 1px;
    height: auto;
  }

  .v-btn__content {
    justify-items: stretch;
    margin: 1px;
  }

  .v-btn--large {
    padding: 1px 4px 1px 2px;
  }

  .v-btn {
    margin: 1px;
  }
  .data-cell {
    width: 65px;
    text-align: right;
  }
  .align-center {
    align-self: center;
  }
  .text-muted {
    opacity: 0.5;
  }
  .details-cell-container {
    display: inline-flex;
    flex-shrink: 1 !important;
    flex-grow: 0 !important;
  }
}
</style>
